import axios from "axios";
import { useEffect, useState } from "react";
import { Alert, Button, Container, Form, Modal, Table, Spinner, OverlayTrigger, Tooltip } from "react-bootstrap";
import getAPI from "../../service/getAPI";
import { format } from "date-fns";
import QueryCountCell from "./QueryCountCell";
// { search, setSearch }
const InquiryList = ({ search, setSearch }) => {
  const { master } = getAPI();
  const [inquiries, setInquiries] = useState([]);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(() => {
    // Get saved limit or default to 10
    const saved = localStorage.getItem("pageLimit");
    return saved ? parseInt(saved, 10) : 10;
  });

  useEffect(() => {
    // Store current limit in localStorage
    localStorage.setItem("pageLimit", limit);
  }, [limit]);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const [selectedInquiry, setSelectedInquiry] = useState(null);
  const [modalType, setModalType] = useState(""); // 'recourier' | 'refund' | 'attempt'
  const [orderList, setOrderList] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [refundAmount, setRefundAmount] = useState("");
  const [refundMethod, setRefundMethod] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [remark, setRemark] = useState("");
  const [remarksList, setRemarksList] = useState([]);
  const [isFetchingOrders, setIsFetchingOrders] = useState(false);
  const [orderFetchError, setOrderFetchError] = useState("");
  const [orderFetchSuccess, setOrderFetchSuccess] = useState("");
  // const [search, setSearch] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [modalError, setModalError] = useState("");
  const [confirmResolve, setConfirmResolve] = useState({ show: false, inquiryId: null });
  const [hovered, setHovered] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [showAssignModal, setShowAssignModal] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState("");
  const [courierPartners, setCourierPartners] = useState([]);
  const [loadingCourierPartners, setLoadingCourierPartners] = useState(false);

  const handleOpenPopup = () => setShowPopup(true);
  const handleClosePopup = () => setShowPopup(false);

  const fetchInquiries = async (page, limit) => {
    setLoading(true);
    setError("");
    try {
      const response = await axios.post(master.InquiryList, {
        page,
        limit,
        search,
        from_date: fromDate,
        to_date: toDate,
      });

      const result = response.data?.data;
      console.log("result", result);
      setInquiries(result?.data || []);
      setTotalRecords(result?.pagination?.totalRecords || 0);
      setTotalPages(result?.pagination?.totalPages || 1);
    } catch (err) {
      console.error(err);
      setError("Failed to fetch inquiries.");
    } finally {
      setLoading(false);
    }
  };

  // const fetchOrdersByMobile = async (mobile) => {
  //   try {
  //     const response = await axios.post(master.inquiryOrderList, {
  //       order_mobile_no: mobile,
  //     });
  //     setOrderList(response.data?.data || []);
  //   } catch (err) {
  //     console.error(err);
  //     setError("Failed to fetch order list.");
  //   }
  // };

  const fetchOrdersByMobile = async () => {
    try {
      setIsFetchingOrders(true);
      setOrderFetchError("");
      setOrderFetchSuccess("");

      if (!mobileNumber || mobileNumber.length !== 10) {
        setOrderFetchError("Please enter a valid 10-digit mobile number");
        return;
      }

      // Clear validation error if 10 digits are entered
      setOrderFetchError("");

      const response = await axios.post(master.getmobileorderlist, {
        order_mobile_no: mobileNumber,
      });

      if (response.data?.data?.length === 0) {
        setOrderFetchError("No orders found for the given mobile number.");
        setOrderList([]);
        return;
      }

      setOrderList(response.data?.data || []);
      setOrderFetchSuccess(`Found ${response.data.data.length} order(s) for this mobile number show in below dropdown `);

    } catch (err) {
      console.error(err);
      setOrderFetchError("Failed to fetch order list. Please try again.");
    } finally {
      setIsFetchingOrders(false);
    }
  };

  const formatDateTime = (utcDateStr) => {
    if (!utcDateStr) return '-';
    const date = new Date(utcDateStr);
    // Offset IST: UTC + 5 hours 30 minutes = 330 minutes
    const istOffset = 330 * 60 * 1000;
    const istDate = new Date(date.getTime() + istOffset);

    return istDate.toLocaleString('en-IN', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    });
  };

  const handleOpenModal = (type, inquiry) => {
    // Reset all modal-related states first
    handleCloseModal();

    // Set the new modal type
    setModalType(type);

    if (!inquiry || !inquiry.inquiry_id) {
      setError("Invalid query selected.");
      return;
    }

    // Set the selected inquiry
    setSelectedInquiry(inquiry);

    // For attempt modal, set mobile number and fetch remarks
    if (type === 'attempt') {
      setMobileNumber(inquiry.order_mobile_no || "");
      setRemark("");
      setRemarksList([]);
      fetchAttemptRemarks(inquiry.order_mobile_no);
    } else {
      // For other modals (recourier, refund), clear mobile number and order list
      setMobileNumber("");
      setOrderList([]);
      setOrderFetchError("");
      setOrderFetchSuccess("");
      setSelectedOrder(null);
      fetchOrdersByMobile();
    }

    // Reset other form fields
    setRefundAmount("");
    setRefundMethod("");
  };

  const handleCloseModal = () => {
    // Reset all modal-related states
    setModalType("");
    setSelectedInquiry(null);
    setSelectedOrder(null);
    setMobileNumber("");
    setRemark("");
    setRemarksList([]);
    setRefundAmount("");
    setRefundMethod("");
    setModalError("");
    setOrderList([]);
    setOrderFetchError("");
    setOrderFetchSuccess("");
    setIsFetchingOrders(false);
  };

  // const handleSubmitRecourier = async () => {
  //   if (!selectedOrder || !selectedInquiry?.inquiry_id) return;

  //   try {
  //     await axios.post(master.sendInquiryRecourier, {
  //       inquiry_id: selectedInquiry.inquiry_id,
  //       order_mobile_no: selectedInquiry.order_mobile_no,
  //       order_code: selectedOrder.order_code,
  //     });
  //     setSuccess("Recourier request sent successfully.");
  //     setModalType("");
  //     setInquiries((prev) =>
  //       prev.map((i) =>
  //         i.inquiry_id === selectedInquiry.inquiry_id
  //           ? { ...i, resolution_type: "recourier" }
  //           : i
  //       )
  //     );
  //   } catch (err) {
  //     console.error(err);
  //     setError("Failed to send recourier.");
  //   }
  // };

  const handleSubmitRecourier = async () => {
    if (!selectedOrder || !selectedInquiry?.inquiry_id) return;

    try {
      await axios.post(master.sendInquiryRecourier, {
        inquiry_id: selectedInquiry.inquiry_id,
        order_mobile_no: mobileNumber,
        order_code: selectedOrder.order_code,
      });
      setSuccess("Recourier request sent successfully.");
      setModalType("");
      setInquiries((prev) =>
        prev.map((i) =>
          i.inquiry_id === selectedInquiry.inquiry_id
            ? { ...i, resolution_type: "recourier" }
            : i
        )
      );
      fetchInquiries(page, limit);
    } catch (err) {
      console.error(err);
      setError("Failed to send recourier.");
    }
  };

  // const handleSubmitRefund = async () => {
  //   if (!selectedOrder || !refundMethod || !refundAmount || !selectedInquiry?.inquiry_id) return;

  //   try {
  //     await axios.post(master.sendInquiryRefund, {
  //       inquiry_id: selectedInquiry.inquiry_id,
  //       order_mobile_no: selectedInquiry.order_mobile_no,
  //       order_code: selectedOrder.order_code,
  //       refund_amount: parseFloat(refundAmount),
  //       refund_method: refundMethod,
  //     });
  //     setSuccess("Refund processed successfully.");
  //     setModalType("");
  //     setInquiries((prev) =>
  //       prev.map((i) =>
  //         i.inquiry_id === selectedInquiry.inquiry_id
  //           ? { ...i, resolution_type: "refund" }
  //           : i
  //       )
  //     );
  //   } catch (err) {
  //     console.error(err);
  //     setError("Failed to process refund.");
  //   }
  // };

  const handleSubmitRefund = async () => {
    if (!selectedOrder || !refundMethod || !refundAmount || !selectedInquiry?.inquiry_id) return;

    try {
      await axios.post(master.sendInquiryRefund, {
        inquiry_id: selectedInquiry.inquiry_id,
        order_mobile_no: mobileNumber,
        order_code: selectedOrder.order_code,
        refund_amount: parseFloat(refundAmount),
        refund_method: refundMethod,
      });
      setSuccess("Refund processed successfully.");
      setModalType("");
      setInquiries((prev) =>
        prev.map((i) =>
          i.inquiry_id === selectedInquiry.inquiry_id
            ? { ...i, resolution_type: "refund" }
            : i
        )
      );
      fetchInquiries(page, limit);
    } catch (err) {
      console.error(err);
      setError("Failed to process refund.");
    }
  };

  // const handleSubmitAttempt = async () => {
  //   setModalError(""); // Clear previous errors

  //   if (!selectedInquiry?.inquiry_id) {
  //     setModalError("No inquiry selected.");
  //     return;
  //   }

  //   if (!remark || remark.trim() === '') {
  //     setModalError("Please enter a remark before attempting.");
  //     return;
  //   }

  //   try {
  //     await axios.post(master.sendInquiryAttempt, {
  //       inquiry_id: selectedInquiry.inquiry_id,
  //       remark: remark.trim(),
  //       order_mobile_no: selectedInquiry.order_mobile_no,
  //       is_active: true
  //     });
  //     setSuccess("Attempt saved successfully.");
  //     setModalType("");
  //     setRemark(""); // Clear the remark field
  //     fetchInquiries(page, limit);

  //     setTimeout(() => {
  //       fetchAttemptRemarks(selectedInquiry.order_mobile_no);
  //     }, 300);
  //   } catch (err) {
  //     console.error(err);
  //     setError(err.response?.data?.message || "Failed to save attempt. Please try again.");
  //   }
  // };

  const handleSubmitAttempt = async () => {
    setModalError(""); // Clear previous errors

    if (!selectedInquiry?.inquiry_id) {
      setModalError("No query selected.");
      return;
    }

    if (!remark || remark.trim() === '') {
      setModalError("Please enter a remark before attempting.");
      return;
    }

    try {
      await axios.post(master.sendInquiryAttempt, {
        inquiry_id: selectedInquiry.inquiry_id,
        remark: remark.trim(),
        order_mobile_no: selectedInquiry.order_mobile_no,
        is_active: true,
        last_attempt_by: 3,
      });

      setSuccess("Attempt saved successfully.");
      setRemark(""); // Clear the remark field

      // Close the modal first
      setModalType("");

      // Then refresh the data
      fetchInquiries(page, limit);

      // Fetch attempt remarks after a short delay
      setTimeout(() => {
        fetchAttemptRemarks(selectedInquiry.order_mobile_no);
      }, 300);

    } catch (err) {
      console.error(err);
      setError(err.response?.data?.message || "Failed to save attempt. Please try again.");
    }
  };

  const fetchAttemptRemarks = async (mobileNo) => {
    try {
      if (!mobileNo) {
        setError("Please select an query with a mobile number first.");
        return;
      }
      console.log("selectedInquiry", selectedInquiry);
      console.log("mobileNo", mobileNo);
      const url = master.getInquiryAttemptRemarkList;
      const response = await axios.post(url, {
        order_mobile_no: mobileNo,
      });
      setRemarksList([]);
      const remarks = response.data?.data || [];
      console.log("remarks", remarks);
      setRemarksList(remarks);
    } catch (err) {
      setError(err.response?.data?.message || "Failed to fetch attempt remarks.");
    }
  };

  const handleResolveClick = (inquiryId) => {
    setConfirmResolve({ show: true, inquiryId });
  };

  const handleResolveConfirm = async () => {
    if (!confirmResolve.inquiryId) return;

    try {
      await axios.post(master.AttemptRemarkResolveList, {
        inquiry_id: confirmResolve.inquiryId,
        resolved_by: 3,
      });
      setSuccess("Query resolved successfully.");
      setConfirmResolve({ show: false, inquiryId: null });
      fetchInquiries(page, limit);
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.message || "Failed to resolve query.");
      setConfirmResolve({ show: false, inquiryId: null });
    }
  };

  const handleResolveCancel = () => {
    setConfirmResolve({ show: false, inquiryId: null });
  };

  const fetchCourierPartners = async () => {
    setLoadingCourierPartners(true);
    setModalError("");
    try {
      const response = await axios.get(master.getCourierPartnerList);

      if (response.data && response.data.flag === 1) {
        const partners = response.data.data || [];
        setCourierPartners(partners);
      } else {
        const errorMsg = response.data?.message || "Failed to load courier partners";
        setModalError(errorMsg);
      }
    } catch (err) {
      const errorMsg = err.response?.data?.message || "Error fetching courier partners. Please try again.";
      setModalError(errorMsg);
    } finally {
      setLoadingCourierPartners(false);
    }
  };

  const handleAssignClick = (inquiry) => {
    setSelectedInquiry(inquiry);
    setShowAssignModal(true);
    fetchCourierPartners();
  };

  const handleAssignSubmit = async () => {
    if (!selectedEmployee) {
      setModalError("Please select a Courier Partner");
      return;
    }

    try {
      const payload = {
        inquiry_id: selectedInquiry.inquiry_id.toString(),
        assign_to: selectedEmployee,
        assigned_by: 3,  // Changed from assign_by to assigned_by
      };

      console.log("Sending assign request with payload:", payload);

      const response = await axios.post(master.assignInquiry, payload);
      console.log("Assign response:", response.data);

      setSuccess("Inquiry assigned successfully!");
      setShowAssignModal(false);
      setSelectedEmployee("");
      fetchInquiries(page, limit);
    } catch (err) {
      console.error(err);
      setError("Failed to assign inquiry. Please try again.");
    }
  };

  useEffect(() => {
    fetchInquiries(page, limit);
  }, [page, limit, search, fromDate, toDate]);

  useEffect(() => {
    if (error) {
      const timeout = setTimeout(() => setError(""), 3000);
      return () => clearTimeout(timeout);
    }
  }, [error]);

  useEffect(() => {
    if (success) {
      const timeout = setTimeout(() => setSuccess(""), 3000);
      return () => clearTimeout(timeout);
    }
  }, [success]);

  return (
    <>
      {/* <main id="main" className="main"> */}
      <div className="container-fluid p-0">

        {loading && (
          <div className="text-center">
            <Spinner animation="border" />
          </div>
        )}
        {error && <Alert variant="danger">{error}</Alert>}
        {success && <Alert variant="success">{success}</Alert>}

        <Form className="row g-2 mb-3">
          <div className="col-md-3 gap-2">
            <Form.Control
              type="text"
              placeholder="Search by mobile, remark etc."
              value={search}
              onChange={(e) => {
                const input = e.target.value;
                const cleaned = input.replace(/\s+/g, ''); // removes all whitespace
                setSearch(cleaned);
              }}
            />
          </div>
          <div className="col-md-2">
            <Form.Control
              type="date"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
            />
          </div>
          <div className="col-md-2">
            <Form.Control
              type="date"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
            />
          </div>
          <div className="col-md-2 gap-2 d-flex">
            <Button
              variant="primary"
              onClick={() => {
                setPage(1);
                // fetchInquiries(page, limit);
              }}
            >
              Search
            </Button>
            <Button
              variant="secondary"
              onClick={() => {
                setSearch("");
                setFromDate("");
                setToDate("");
                // setPage(1);
                // fetchInquiries(page, limit);
              }}
            >
              Reset
            </Button>
          </div>
        </Form>

        <div className="table-responsive">
          <Table striped bordered hover responsive="lg">
            <thead className="table-secondary">
              <tr>
                <th>No</th>
                <th>Customer Name</th>
                <th>Mobile No</th>
                {/* <th>Address</th> */}
                <th>Employee Name</th>
                <th>Remark</th>
                <th>Priority</th>
                <th>Query log</th>
                <th>Created At</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {inquiries.length > 0 ? (
                inquiries.map((item, index) => (
                  <tr key={item.inquiry_id || index}>
                    <td>{index + 1}</td>
                    <td>{item.customer_name || "-"}</td>
                    {/* <td>{item.phone_number || "-"}</td> */}
                    <td>{item.order_mobile_no || "-"}</td>
                    {/* <td>
                      {[item.address, item.state, item.pincode]
                        .filter(Boolean)
                        .join(", ") || "-"}
                    </td> */}
                    <td>{item.emp_name || "-"}</td>
                    <td>{item.inquiry_remark || "-"}</td>
                    <td>
                      <span
                        className="badge"
                        style={{
                          backgroundColor:
                            item.PRIORITY === "LOW"
                              ? "yellow"
                              : item.PRIORITY === "MEDIUM"
                                ? "orange"
                                : item.PRIORITY === "HIGH"
                                  ? "red"
                                  : "gray",
                          color: item.PRIORITY === "LOW" ? "black" : "white",
                          padding: "5px 10px",
                          borderRadius: "6px",
                          fontWeight: "bold"
                        }}
                      >
                        {item.PRIORITY || "-"}
                      </span>
                    </td>


                    <QueryCountCell
                      count={item.query_count}
                      inquiry_id={item.inquiry_id}
                    />
                    <td>{item.created_at
                      ? format(new Date(item.created_at), "dd-MM-yyyy hh:mm a")
                      : "N/A"}</td>
                    <td>
                      <div className="d-flex gap-1" style={{ minWidth: '300px', overflowX: 'auto', whiteSpace: 'nowrap' }}>
                        <Button
                          variant="info"
                          size="sm"
                          className="text-nowrap border-0"
                          style={{ backgroundColor: '#0dcaf0' }}
                          onClick={() => handleOpenModal("recourier", item)}
                        >
                          Recourier
                        </Button>
                        <Button
                          variant="warning"
                          size="sm"
                          className="text-nowrap border-0"
                          style={{ backgroundColor: '#ffc107' }}
                          onClick={() => handleOpenModal("refund", item)}
                        >
                          Refund
                        </Button>
                        <Button
                          variant={item.attempt_count > 0 ? "secondary" : "primary"}
                          size="sm"
                          className="text-nowrap border-0"
                          style={{
                            backgroundColor: item.attempt_count > 0 ? '#6c757d' : '#0d6efd'
                          }}
                          onClick={() => {
                            setMobileNumber(item.order_mobile_no);
                            handleOpenModal("attempt", item);
                          }}
                        >
                          {item.attempt_count > 0 ? 'Re-attempt' : 'Attempt'}
                        </Button>
                        <Button
                          variant="success"
                          size="sm"
                          className="text-nowrap border-0"
                          style={{ backgroundColor: '#198754' }}
                          onClick={() => handleResolveClick(item.inquiry_id)}
                        >
                          Resolve
                        </Button>
                        <Button
                          variant="info"
                          size="sm"
                          className="text-nowrap border-0"
                          style={{ backgroundColor: '#6366F1', color: 'white' }}
                          onClick={() => handleAssignClick(item)}
                        >
                          Assign
                        </Button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8" className="text-center">
                    No inquiries found.
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>

        <div className="d-flex justify-content-between align-items-center mt-3">
          <div>Total Records: {totalRecords}</div>
          <div className="d-flex align-items-center">
            <Form.Label className="me-2 mb-0">Show:</Form.Label>
            <Form.Select
              value={limit}
              onChange={(e) => {
                setLimit(Number(e.target.value));
                setPage(1);
              }}
              style={{ width: "100px" }}
            >
              {[10, 25, 50, 100].map((num) => (
                <option key={num} value={num}>
                  {num}
                </option>
              ))}
            </Form.Select>
            <Button className="mx-2" disabled={page === 1} onClick={() => setPage(page - 1)}>
              &laquo; Prev
            </Button>
            <Form.Select
              value={page}
              onChange={(e) => setPage(Number(e.target.value))}
              style={{ width: "100px" }}
            >
              {Array.from({ length: totalPages }, (_, i) => (
                <option key={i + 1} value={i + 1}>
                  Page {i + 1}
                </option>
              ))}
            </Form.Select>
            <Button
              className="mx-2"
              disabled={page === totalPages}
              onClick={() => setPage(page + 1)}
            >
              Next &raquo;
            </Button>
          </div>
        </div>

        {/* Modal */}
        {/* <Modal show={modalType === "recourier" || modalType === "refund"} onHide={() => setModalType("")}>
          <Modal.Header closeButton>
            <Modal.Title>
              {modalType === "recourier" ? "Send Recourier" : "Process Refund"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group>
              <Form.Label>Select Order</Form.Label>
              <Form.Select
                value={selectedOrder?.order_code || ""}
                onChange={(e) => {
                  const selected = orderList.find(
                    (o) => o.order_code === String(e.target.value)
                  );
                  setSelectedOrder(selected);
                  if (modalType === "refund" && selected) {
                    setRefundAmount();
                  }
                }}
              >
                <option value="">-- Select --</option>
                {orderList.map((order) => (
                  <option
                    key={order.order_code}
                    value={order.order_code}
                  >
                    {`${order.order_code} - ${order.product}`}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>

            {modalType === "refund" && (
              <>
                <Form.Group className="mt-3">
                  <Form.Label>Refund Amount</Form.Label>
                  <Form.Control
                    type="number"
                    value={refundAmount}
                    onChange={(e) => setRefundAmount(e.target.value)}
                  />
                </Form.Group>

                <Form.Group className="mt-3">
                  <Form.Label>UPI No.</Form.Label>
                  <Form.Control
                    type="text"
                    value={refundMethod}
                    onChange={(e) => setRefundMethod(e.target.value)}
                    placeholder="e.g. 7894561230"
                  />
                </Form.Group>
              </>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setModalType("")}>
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={
                modalType === "recourier" ? handleSubmitRecourier : handleSubmitRefund
              }
              disabled={!selectedOrder || (modalType === "refund" && !refundAmount)}
            >
              Submit
            </Button>
          </Modal.Footer>
        </Modal> */}
        <Modal show={modalType === "recourier" || modalType === "refund"} onHide={() => setModalType("")}>
          <Modal.Header closeButton>
            <Modal.Title>
              {modalType === "recourier" ? "Send Recourier" : "Process Refund"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {/* here i want to write mobile number manually and click get details button  but here already fetch number that i don't want to fetch */}

            <Form.Group className="mb-3">
              <Form.Label>Mobile Number</Form.Label>
              <Form.Control
                type="text"
                value={mobileNumber || ""}
                onChange={(e) => {
                  setMobileNumber(e.target.value);
                  // Clear validation error when input changes
                  if (e.target.value.length === 10) {
                    setOrderFetchError("");
                  }
                }}
                placeholder="Enter mobile number"
              />
            </Form.Group>
            {isFetchingOrders && (
              <div className="text-center mb-3">
                <Spinner animation="border" size="sm" /> Fetching orders...
              </div>
            )}
            {orderFetchError && (
              <Alert variant="danger" className="mb-3">
                {orderFetchError}
              </Alert>
            )}
            {orderFetchSuccess && (
              <Alert variant="success" className="mb-3">
                {orderFetchSuccess}
              </Alert>
            )}
            {mobileNumber.length === 10 && (
              <div className="text-end mb-3">
                <Button
                  variant="primary"
                  onClick={fetchOrdersByMobile}
                  className="px-4"
                  disabled={isFetchingOrders}
                >
                  Get Details
                </Button>
              </div>
            )}
            <Form.Group className="mb-3">
              <Form.Label>Select Order</Form.Label>
              <Form.Select
                value={selectedOrder?.order_code || ""}
                onChange={(e) => {
                  const selected = orderList.find(
                    (o) => o.order_code === String(e.target.value)
                  );
                  setSelectedOrder(selected);
                  if (modalType === "refund" && selected) {
                    setRefundAmount();
                  }
                }}
              >
                <option value="">-- Select --</option>
                {orderList.map((order) => (
                  <option
                    key={order.order_code}
                    value={order.order_code}
                  >
                    {`${order.order_code} - ${order.customer_name} - ${order.product}`}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>

            {modalType === "refund" && (
              <>
                <Form.Group className="mt-3">
                  <Form.Label>Refund Amount</Form.Label>
                  <Form.Control
                    type="number"
                    value={refundAmount}
                    onChange={(e) => setRefundAmount(e.target.value)}
                  />
                </Form.Group>

                <Form.Group className="mt-3">
                  <Form.Label>UPI No.</Form.Label>
                  <Form.Control
                    type="text"
                    value={refundMethod}
                    onChange={(e) => setRefundMethod(e.target.value)}
                    placeholder="e.g. 7894561230"
                  />
                </Form.Group>
              </>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setModalType("")}>
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={
                modalType === "recourier" ? handleSubmitRecourier : handleSubmitRefund
              }
              disabled={!selectedOrder || (modalType === "refund" && !refundAmount)}
            >
              Submit
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Attempt Modal */}
        <Modal show={modalType === "attempt"} onHide={handleCloseModal}>
          <Modal.Header closeButton>
            <Modal.Title>Attempt</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {modalError && (
              <Alert variant="danger" className="mb-3">
                {modalError}
              </Alert>
            )}
            <Form>
              <Form.Group controlId="mobileNumber" className="mb-3">
                <Form.Label>Mobile Number</Form.Label>
                <Form.Control
                  type="text"
                  value={mobileNumber}
                  readOnly
                />
              </Form.Group>
              <Form.Group controlId="remark" className="mt-3">
                <Form.Label>Remark</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={remark}
                  onChange={(e) => setRemark(e.target.value)}
                  placeholder="Enter your remark..."
                />
              </Form.Group>
              {/* <div className="mt-3">
                <h6>Previous Remarks:</h6>
                <ul className="list-group">
                  {Array.isArray(remarksList) && remarksList.length > 0 ? (
                    remarksList.map((remarkObj, index) => (
                      <li key={index} className="list-group-item">
                        {remarkObj?.remark || <em className="text-danger">[Empty remark]</em>}
                      </li>
                    ))
                  ) : (
                    <li className="list-group-item text-muted">No previous remarks found</li>
                  )}
                </ul>
              </div> */}
              <ul className="list-group mt-3">
                {Array.isArray(remarksList) && remarksList.length > 0 ? (
                  remarksList.map((remarkObj, index) => (
                    <li key={index} className="list-group-item">
                      <div>{remarkObj?.remark || <span className="text-danger">[Missing remark]</span>}</div>
                      <small className="text-muted">
                        {remarkObj?.created_at ? formatDateTime(remarkObj.created_at) : 'N/A'}
                      </small>
                    </li>
                  ))
                ) : (
                  <li className="list-group-item text-muted">No previous remarks found</li>
                )}
              </ul>

            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setModalType("")}>
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={handleSubmitAttempt}
            // disabled={!remark}
            >
              Submit
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Resolve Confirmation Modal */}
        <Modal show={confirmResolve.show} onHide={handleResolveCancel} centered>
          <Modal.Header closeButton>
            <Modal.Title>Confirm Resolution</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>Are you sure you want to resolve this query?</p>
            <p className="text-muted">This action cannot be undone.</p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleResolveCancel}>
              Cancel
            </Button>
            <Button variant="success" onClick={handleResolveConfirm}>
              Yes, Resolve
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Assign Modal */}
        <Modal show={showAssignModal} onHide={() => setShowAssignModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Assign Inquiry</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {modalError && <Alert variant="danger">{modalError}</Alert>}
            <Form.Group className="mb-3">
              <Form.Label>Select Employee</Form.Label>
              {loadingCourierPartners ? (
                <div className="text-center">
                  <Spinner animation="border" size="sm" /> Loading courier partners...
                </div>
              ) : (
                <Form.Select
                  value={selectedEmployee}
                  onChange={(e) => setSelectedEmployee(e.target.value)}
                >
                  <option value="">-- Select Courier Partner --</option>
                  {courierPartners.map((partner) => (
                    <option key={partner.emp_id} value={partner.emp_id}>
                      {partner.emp_name}
                    </option>
                  ))}
                </Form.Select>
              )}
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowAssignModal(false)}>
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={handleAssignSubmit}
              disabled={!selectedEmployee}
            >
              Assign
            </Button>
          </Modal.Footer>
        </Modal>

      </div>
      {/* </main> */}
    </>
  );
};

export default InquiryList;
